import React, { Component } from 'react'

import Sales from 'components/Sales/Sales';

export default class SalesView extends Component {
    render() {
        return (
            <div className="fade-show">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Afiliaciones</h1>
                    </div>
                </div>

                <Sales />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/views/SalesView/SalesView.jsx